import { render, staticRenderFns } from "./DataContributorOnboardingStep3.vue?vue&type=template&id=2ff93a23"
import script from "./DataContributorOnboardingStep3.vue?vue&type=script&lang=js"
export * from "./DataContributorOnboardingStep3.vue?vue&type=script&lang=js"
import style0 from "./DataContributorOnboardingStep3.vue?vue&type=style&index=0&id=2ff93a23&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports